import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useUserPermissions } from '../hooks/useUserPermissions';

interface AccountingAdminRouteProps {
  children?: React.ReactNode;
}

/**
 * Route guard for Accounting admin pages
 * Requires the user to have any accounting permission or system.admin
 * Redirects to the main admin dashboard if permission is missing
 */
export const AccountingAdminRoute: React.FC<AccountingAdminRouteProps> = ({ children }) => {
  const { hasPermission, isLoading } = useUserPermissions();

  // Show loading while checking permissions
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Check if user has any accounting permission (view, all, admin, gphtl) or system.admin
  const hasAccountingPermission =
    hasPermission('system.admin') ||
    hasPermission('accounting.admin') ||
    hasPermission('accounting.all') ||
    hasPermission('accounting.view') ||
    hasPermission('accounting.gphtl');

  if (!hasAccountingPermission) {
    return <Navigate to="/admin/market-compass" replace />;
  }

  return <>{children || <Outlet />}</>;
};